export default "__VITE_ASSET__pSDGwijD__"